export default {

  user: {
      id: 0,
      name: "Anish",
      number: "+91 91231 40293",
      pic: "images/asdsd12f34ASd231.png"
  },
  contactList: [
    {
      id: 0,
      name: "Anish",
      number: "+91 91231 40293",
      pic: "images/asdsd12f34ASd231.png",
      lastSeen: "Apr 29 2018 17:58:02"
    },
    {
      id: 1,
      name: "Nitin",
      number: "+91 98232 37261",
      pic: "images/Ass09123asdj9dk0qw.jpg",
      lastSeen: "Apr 28 2018 22:18:21"
    },
    {
      id: 2,
      name: "Sanjay",
      number: "+91 72631 2937",
      pic: "images/asd1232ASdas123a.png",
      lastSeen: "Apr 28 2018 19:23:16"
    },
    {
      id: 3,
      name: "Suvro Mobile",
      number: "+91 98232 63547",
      pic: "images/Alsdk120asdj913jk.jpg",
      lastSeen: "Apr 29 2018 11:16:42"
    },
    {
      id: 4,
      name: "Dee",
      number: "+91 72781 38213",
      pic: "images/dsaad212312aGEA12ew.png",
      lastSeen: "Apr 27 2018 17:28:10"
    }
  ],
  groupList: [
    {
      id: 1,
      name: "Programmers",
      members: [0, 1, 3],
      pic: "images/0923102932_aPRkoW.jpg"
    },
    {
      id: 2,
      name: "Web Developers",
      members: [0, 2],
      pic: "images/1921231232_Ag1asE.png"
    },
    {
      id: 3,
      name: "notes",
      members: [0],
      pic: "images/8230192232_asdEWq2.png"
    }
  ],
    messages: [
    {
      id: 0,
      sender: 2,
      body: "where are you, buddy?",
      time: "April 25, 2018 13:21:03",
      status: 2,
      recvId: 0,
      recvIsGroup: false
    },
    {
      id: 1,
      sender: 0,
      body: "at home",
      time: "April 25, 2018 13:22:03",
      status: 2,
      recvId: 2,
      recvIsGroup: false
    },
    {
      id: 2,
      sender: 0,
      body: "how you doin'?",
      time: "April 25, 2018 18:15:23",
      status: 2,
      recvId: 3,
      recvIsGroup: false
    },
    {
      id: 3,
      sender: 3,
      body: "i'm fine...wat abt u?",
      time: "April 25, 2018 21:05:11",
      status: 2,
      recvId: 0,
      recvIsGroup: false
    },
    {
      id: 4,
      sender: 0,
      body: "i'm good too",
      time: "April 26, 2018 09:17:03",
      status: 1,
      recvId: 3,
      recvIsGroup: false
    },
    {
      id: 5,
      sender: 3,
      body: "anyone online?",
      time: "April 27, 2018 18:20:11",
      status: 0,
      recvId: 1,
      recvIsGroup: true
    },
    {
      id: 6,
      sender: 1,
      body: "have you seen infinity war?",
      time: "April 27, 2018 17:23:01",
      status: 1,
      recvId: 0,
      recvIsGroup: false
    },
    {
      id: 7,
      sender: 0,
      body: "are you going to the party tonight?",
      time: "April 27, 2018 08:11:21",
      status: 2,
      recvId: 2,
      recvIsGroup: false
    },
    {
      id: 8,
      sender: 2,
      body: "no, i've some work to do..are you?",
      time: "April 27, 2018 08:22:12",
      status: 2,
      recvId: 0,
      recvIsGroup: false
    },
    {
      id: 9,
      sender: 0,
      body: "yup",
      time: "April 27, 2018 08:31:23",
      status: 1,
      recvId: 2,
      recvIsGroup: false
    },
    {
      id: 10,
      sender: 0,
      body: "if you go to the movie, then give me a call",
      time: "April 27, 2018 22:41:55",
      status: 2,
      recvId: 4,
      recvIsGroup: false
    },
    {
      id: 11,
      sender: 1,
      body: "yeah, i'm online",
      time: "April 28 2018 17:10:21",
      status: 0,
      recvId: 1,
      recvIsGroup: true
    }
  ]



  // getById: function getById (id, parent) {
  //   parent ? parent.getElementById(id) : this.getById(id, document)
  // }
  //
  // getById: function getById(id, parent) {
  //   return
  // },
  // getByClass: (className, parent) => {
  //  return  parent ? parent.getElementsByClassName(className) : getByClass(className, document)
  // },
  //
  // teste: this.getById("\"chat-list-area\"")

// DOM: {
//   chatListArea: this.getById("chat-list-area")
  // chatListArea: this.getById("chat-list-area")
// }
  //   messageArea: this.getById("message-area"),
  //   inputArea: this.getById("input-area"),
  //   chatList: this.getById("chat-list"),
  //   messages: this.getById("messages"),
  //   chatListItem: this.getByClass("chat-list-item"),
  //   messageAreaName: this.getById("name", this.messageArea),
  //   messageAreaPic: this.getById("pic", this.messageArea),
  //   messageAreaNavbar: this.getById("navbar", this.messageArea),
  //   messageAreaDetails: this.getById("details", this.messageAreaNavbar),
  //   messageAreaOverlay: this.getByClass("overlay", this.messageArea)[0],
  //   messageInput: this.getById("input"),
  //   profileSettings: this.getById("profile-settings"),
  //   profilePic: this.getById("profile-pic"),
  //   profilePicInput: this.getById("profile-pic-input"),
  //   inputName: this.getById("input-name"),
  //   username: this.getById("username"),
  //   displayPic: this.getById("display-pic"),
  // }
  //
  //
  //
  //
  //
  //
  // let mClassList = (element) => {
  //   return {
  //     add: (className) => {
  //       element.classList.add(className);
  //       return mClassList(element);
  //     },
  //     remove: (className) => {
  //       element.classList.remove(className);
  //       return mClassList(element);
  //     },
  //     contains: (className, callback) => {
  //       if (element.classList.contains(className))
  //         callback(mClassList(element));
  //     }
  //   };
  // };
  //
  // // 'areaSwapped' is used to keep track of the swapping
  // // of the main area between chatListArea and messageArea
  // // in mobile-view
  // let areaSwapped = false;
  //
  // // 'chat' is used to store the current chat
  // // which is being opened in the message area
  // let chat = null;
  //
  // // this will contain all the chats that is to be viewed
  // // in the chatListArea
  // let chatList = [];
  //
  // // this will be used to store the date of the last message
  // // in the message area
  // let lastDate = "";
  //
  // 'populateChatList' will generate the chat list
  // based on the 'messages' in the datastore

  //
  // let addDateToMessageArea = (date) => {
  //   DOM.messages.innerHTML += `
  //   <div class="mx-auto my-2 bg-primary text-white small py-1 px-2 rounded">
  //     ${date}
  //   </div>
  //   `;
  // };
  //
  // let addMessageToMessageArea = (msg) => {
  //   let msgDate = mDate(msg.time).getDate();
  //   if (lastDate != msgDate) {
  //     addDateToMessageArea(msgDate);
  //     lastDate = msgDate;
  //   }
  //
  //   let htmlForGroup = `
  //   <div class="small font-weight-bold text-primary">
  //     ${contactList.find(contact => contact.id === msg.sender).number}
  //   </div>
  //   `;
  //
  //   let sendStatus = `<i class="${msg.status < 2 ? "far" : "fas"} fa-check-circle"></i>`;
  //
  //   DOM.messages.innerHTML += `
  //   <div class="align-self-${msg.sender === user.id ? "end self" : "start"} p-1 my-1 mx-3 rounded bg-white shadow-sm message-item">
  //     <div class="options">
  //       <a href="#"><i class="fas fa-angle-down text-muted px-2"></i></a>
  //     </div>
  //     ${chat.isGroup ? htmlForGroup : ""}
  //     <div class="d-flex flex-row">
  //       <div class="body m-1 mr-2">${msg.body}</div>
  //       <div class="time ml-auto small text-right flex-shrink-0 align-self-end text-muted" style="width:75px;">
  //         ${mDate(msg.time).getTime()}
  //         ${(msg.sender === user.id) ? sendStatus : ""}
  //       </div>
  //     </div>
  //   </div>
  //   `;
  //
  //   DOM.messages.scrollTo(0, DOM.messages.scrollHeight);
  // };
  //
  // let generateMessageArea = (elem, chatIndex) => {
  //   chat = chatList[chatIndex];
  //
  //   mClassList(DOM.inputArea).contains("d-none", (elem) => elem.remove("d-none").add("d-flex"));
  //   mClassList(DOM.messageAreaOverlay).add("d-none");
  //
  //   [...DOM.chatListItem].forEach((elem) => mClassList(elem).remove("active"));
  //
  //   mClassList(elem).contains("unread", () => {
  //     MessageUtils.changeStatusById({
  //       isGroup: chat.isGroup,
  //       id: chat.isGroup ? chat.group.id : chat.contact.id
  //     });
  //     mClassList(elem).remove("unread");
  //     mClassList(elem.querySelector("#unread-count")).add("d-none");
  //   });
  //
  //   if (window.innerWidth <= 575) {
  //     mClassList(DOM.chatListArea).remove("d-flex").add("d-none");
  //     mClassList(DOM.messageArea).remove("d-none").add("d-flex");
  //     areaSwapped = true;
  //   } else {
  //     mClassList(elem).add("active");
  //   }
  //
  //   DOM.messageAreaName.innerHTML = chat.name;
  //   DOM.messageAreaPic.src = chat.isGroup ? chat.group.pic : chat.contact.pic;
  //
  //   // Message Area details ("last seen ..." for contacts / "..names.." for groups)
  //   if (chat.isGroup) {
  //     let groupMembers = groupList.find(group => group.id === chat.group.id).members;
  //     let memberNames = contactList
  //       .filter(contact => groupMembers.indexOf(contact.id) !== -1)
  //       .map(contact => contact.id === user.id ? "You" : contact.name)
  //       .join(", ");
  //
  //     DOM.messageAreaDetails.innerHTML = `${memberNames}`;
  //   } else {
  //     DOM.messageAreaDetails.innerHTML = `last seen ${mDate(chat.contact.lastSeen).lastSeenFormat()}`;
  //   }
  //
  //   let msgs = chat.isGroup ? MessageUtils.getByGroupId(chat.group.id) : MessageUtils.getByContactId(chat.contact.id);
  //
  //   DOM.messages.innerHTML = "";
  //
  //   lastDate = "";
  //   msgs
  //     .sort((a, b) => mDate(a.time).subtract(b.time))
  //     .forEach((msg) => addMessageToMessageArea(msg));
  // };
  //
  // let showChatList = () => {
  //   if (areaSwapped) {
  //     mClassList(DOM.chatListArea).remove("d-none").add("d-flex");
  //     mClassList(DOM.messageArea).remove("d-flex").add("d-none");
  //     areaSwapped = false;
  //   }
  // };
  //
  // let sendMessage = () => {
  //   let value = DOM.messageInput.value;
  //   DOM.messageInput.value = "";
  //   if (value === "") return;
  //
  //   let msg = {
  //     sender: user.id,
  //     body: value,
  //     time: mDate().toString(),
  //     status: 1,
  //     recvId: chat.isGroup ? chat.group.id : chat.contact.id,
  //     recvIsGroup: chat.isGroup
  //   };
  //
  //   addMessageToMessageArea(msg);
  //   MessageUtils.addMessage(msg);
  //   generateChatList();
  // };
  //
  // let showProfileSettings = () => {
  //   DOM.profileSettings.style.left = 0;
  //   DOM.profilePic.src = user.pic;
  //   DOM.inputName.value = user.name;
  // };
  //
  // let hideProfileSettings = () => {
  //   DOM.profileSettings.style.left = "-110%";
  //   DOM.username.innerHTML = user.name;
  // };
  //
  // window.addEventListener("resize", e => {
  //   if (window.innerWidth > 575) showChatList();
  // });
}


//MessageUtils: {
//
// function  getByGroupId (groupId) {
//     return messages.filter(msg => msg.recvIsGroup && msg.recvId === groupId);
// }
// function  getByContactId(contactId) {
//     return messages.filter(msg => {
//       return !msg.recvIsGroup && ((msg.sender === user.id && msg.recvId === contactId) || (msg.sender === contactId && msg.recvId === user.id));
//     });
// }
//
//
//     getMessages: () => {
//     return messages;
//   },
//     changeStatusById: (options) => {
//     messages = messages.map((msg) => {
//       if (options.isGroup) {
//         if (msg.recvIsGroup && msg.recvId === options.id) msg.status = 2;
//       } else {
//         if (!msg.recvIsGroup && msg.sender === options.id && msg.recvId === user.id) msg.status = 2;
//       }
//       return msg;
//     });
//   },
//     addMessage: (msg) => {
//     msg.id = messages.length + 1;
//     messages.push(msg);
//   }
// //}
//
// function escreve(value) {
//   return 'Voce escreveu ' + value
// }
//
// export default {
//   escreve
//
// }



// WEBPACK FOOTER //
// ./src/features/whatsapp/js/script.js